module.exports = { "default": require("core-js/library/fn/object/entries"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/node_modules/babel-runtime/core-js/object/entries.js
// module id = 430
// module chunks = 1 2 3